// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7be1130a","scoped":false,"hasInlineConfig":false}!./~/vue-pdf/src/annotationLayer.css
// module id = 1017
// module chunks = 0